import React from 'react';
import { NavLink, Link } from 'react-router-dom';
import ConnectionStatus from './ConnectionStatus';
import './Sidebar.css';

const Sidebar = () => {
  const links = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/transactions', label: 'Transactions', icon: '💳' },
    { path: '/charts', label: 'Charts', icon: '📈' },
    { path: '/budget', label: 'Budget', icon: '💰' },
    { path: '/upcoming', label: 'Upcoming', icon: '📅' },
    { path: '/forecast', label: 'Forecast', icon: '🔮' },
    { path: '/cli', label: 'CLI', icon: '⌨️' },
    { path: '/settings', label: 'Settings', icon: '⚙️' },
  ];

  return (
    <aside className="sidebar">
      <Link to="/dashboard" className="sidebar-header-link">
        <div className="sidebar-header">
          <h1 className="sidebar-title">PTADash</h1>
          <p className="sidebar-subtitle">Plain Text Accounting</p>
        </div>
      </Link>

      <div className="sidebar-status">
        <ConnectionStatus />
      </div>

      <nav className="sidebar-nav">
        {links.map((link) => (
          <NavLink
            key={link.path}
            to={link.path}
            className={({ isActive }) =>
              `sidebar-link ${isActive ? 'active' : ''}`
            }
          >
            <span className="sidebar-icon">{link.icon}</span>
            <span className="sidebar-label">{link.label}</span>
          </NavLink>
        ))}
      </nav>
    </aside>
  );
};

export default Sidebar;
